import React, { useEffect, useState } from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import TopImage from "../components/common/TopImage";

const baseURL = process.env.PUBLIC_URL + '/assets/Mpd';

const Mpd = (props) => {
  const commonCellStyle = "text-zinc-800 text-sm tracking-wide  capitalize px-3 py-2 border-b-zinc-200 border-b border-solid";

  const [mpdData, setMpdData] = useState({
    table1Data: [],
    table4Data: [],
    table5Data: [],
    table6Data: [],
    table7Data: [],
    viewLinksTable7: []
  });

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/mpdData.json`)
      .then((res) => res.json())
      .then((data) => setMpdData(data))
      .catch((err) => console.error("Error loading MPD data:", err));
  }, []);

  // Construct full URLs for view links
  const viewLinksTable7 = mpdData.viewLinksTable7.map(link => baseURL + '/' + link);

  // Data for Table 1
  const table1Data = mpdData.table1Data;

  // Data for Table 2 - Documents/Information (hardcoded)
  const table2Data = [
    {
      id: 1,
      information: "Copies of affiliation/upgradation letter and recent extension of affiliation",
    },
    {
      id: 2,
      information: "Copies of societies /trust /company registration /renewal certificate, as applicable",
    },
    {
      id: 3,
      information: "Copy of no objection certificate (NOC) issued if applicable, by the state govt./u.t",
    },
    {
      id: 4,
      information: "Copies of recognition certificate under the RTE ACT, 2009, and its renewal if applicable",
    },
    {
      id: 5,
      information: "Copy of valid building safety certificate as per the national building code",
    },
    {
      id: 6,
      information: "Copy of valid fire safety certificate issued by the competent authority",
    },
    {
      id: 7,
      information: "Copy of the self-certification submitted by the school for affiliation/upgradation/extension of affiliation",
    },
    {
      id: 8,
      information: "Copies of valid water, health, and sanitation certificates",
    },
    {
      id: 9,
      information: "Copies of Land Certificates",
    },
    {
      id: 10,
      information: "Sexual harassment committee",
    },
    {
      id: 11,
      information: "Water Sample Report",
    },
  ];

  const viewLinksTable2 = [
    baseURL + '/B1.pdf',
    baseURL + '/B2.pdf',
    baseURL + '/B3.pdf',
    baseURL + '/B4.pdf',
    baseURL + '/B5.pdf',
    baseURL + '/B6.pdf',
    baseURL + '/B7.pdf',
    baseURL + '/B8.pdf',
    baseURL + '/B9.pdf',
    baseURL + '/B10.pdf',
    baseURL + '/B11.pdf',    
  ];

  // Data for Table 3 - Result and Academics (hardcoded)
  const table3Data = [
    {
      id: 1,
      information: "Fees Structure",
    },
    {
      id: 2,
      information: "Annual Academic Calendar",
    },
    {
      id: 3,
      information: "List Of School Management Committee",
    },
    {
      id: 4,
      information: "List of parents teachers association members",
    },
    {
      id: 5,
      information: "Last 3-year result of the board examination as per applicability",
    },
  ];

  const viewLinksTable3 = [
    baseURL + '/C1.pdf',
    baseURL + '/C2.pdf',
    baseURL + '/C3.pdf',
    baseURL + '/C4.pdf',
    baseURL + '/C5.pdf',
  ];

  // Data for Table 4
  const table4Data = mpdData.table4Data;

  const table5Data = mpdData.table5Data;

  const table6Data = mpdData.table6Data;

  const table7Data = mpdData.table7Data;

  const generateTable = (data, viewLinks, showDetails) => (
    <div className="shadow-sm bg-white  max-md:max-w-full overflow-hidden">
    <table className="mx-auto my-auto w-10/12 table-fixed   shadow-2xl">        <thead>
          <tr >
            <th className="text-zinc-800 text-center text-sm font-bold tracking-wide bg-blue-100 p-2 border-b-neutral-200 border-b border-solid w-12 ">S.No.</th>
            <th className={`text-zinc-800 text-sm text-left font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid `}>Information</th>
            {showDetails && (
              <th className={`text-zinc-800 text-sm  font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid  text-left`}>Details</th>
            )}
            {viewLinks && (
              <th className={`text-zinc-800 text-sm text-left font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid ${commonCellStyle} text-left`}>View</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
              <td className={`text-center ${commonCellStyle} p-2 w-1/12`}>{item.id}</td>
              <td className={commonCellStyle}>{item.information}</td>
              {showDetails && <td className={`${commonCellStyle} text-left`}>{item.details}</td>}
              {viewLinks && (
                <td className={`${commonCellStyle} text-left`}>
                  <a
                    href={viewLinks[index]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`text-blue-500 text-xs tracking-wide underline capitalize`}
                  >
                    View
                  </a>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
  const generateTableF = (data) => (
    <div className="shadow-sm bg-white  max-md:max-w-full overflow-hidden ">
      <table className="mx-auto my-auto w-10/12 table-fixed  border border-solid border-zinc-200 shadow-2xl">
        <thead>
          <tr>
            <th className="text-zinc-800 text-center text-sm font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid w-1/12">S.No.</th>
            <th className={`text-zinc-800 text-sm text-left font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid ${commonCellStyle}`}>Information</th>
            <th className={`text-zinc-800 text-sm text-left font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid ${commonCellStyle} text-left`}>Details</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
              <td className={`text-center ${commonCellStyle} p-2 w-1/12`}>{item.id}</td>
              <td className={commonCellStyle}>{item.information}</td>
              {index === data.length - 1 ? (
                <td className={`${commonCellStyle} text-left`}>
                  <a
                    href={item.details}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`text-blue-500 text-xs tracking-wide underline capitalize`}
                  >
                    View
                  </a>
                </td>
              ) : (
                <td className={`${commonCellStyle} text-left`}>{item.details}</td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
// const renderTable5 = (data) => (
//   <div className="shadow-sm bg-white max-md:max-w-full overflow-hidden">
//     <table className="mx-auto my-auto w-10/12 table-fixed border border-solid border-zinc-200 shadow-2xl text-sm">
//       <thead>
//         <tr className="bg-blue-100 text-zinc-800 text-sm font-bold tracking-wide">
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">SL NO.</th>
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">YEAR</th>
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">NO. OF REGISTERED STUDENTS</th>
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">NO. OF STUDENTS PASSED</th>
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">PASS PERCENTAGE</th>
//           <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">REMARKS</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.map((row) => (
//           <tr key={row.id} className="text-zinc-800 tracking-wide">
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.id}</td>
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.year}</td>
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.registered}</td>
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.passed}</td>
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.percentage}</td>
//             <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.remarks}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );
const renderTable5 = (data) => (
  <div className="shadow-sm bg-white max-md:max-w-full overflow-hidden">
    <table className="mx-auto my-auto w-10/12 table-fixed border border-solid border-zinc-200 shadow-2xl text-sm">
      <thead>
        <tr className="bg-blue-100 text-zinc-800 text-sm font-bold tracking-wide">
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">SL NO.</th>
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">YEAR</th>
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">NO. OF REGISTERED STUDENTS</th>
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">NO. OF STUDENTS PASSED</th>
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">PASS PERCENTAGE</th>
          <th className="p-3 border-b border-zinc-200 text-left whitespace-normal break-normal">REMARKS</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.id} className="text-zinc-800 tracking-wide">
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.id}</td>
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.year}</td>
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.registered}</td>
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.passed}</td>
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.percentage}</td>
            <td className="p-3 border-b border-zinc-200 whitespace-normal break-normal">{row.remarks}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);



  return (
    <div>
      <NavBar/>
      <TopImage text="Mandatory Public Disclosure"/>
      <div className="flex flex-col justify-center items-center mt-20 max-md:mt-8 max-md:max-w-full">

      <div className="text-black text-center text-xl  font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 ">
        A: General Information
      </div>
      {generateTable(table1Data, false, true)}

      <div className="text-black text-center text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10 ">
        B: Documents/Information
      </div>
      {generateTable(table2Data, viewLinksTable2)}

      <div className="text-black text-center text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10">
        C: Result and Academics
      </div>
      {generateTable(table3Data, viewLinksTable3)}
      <div className="text-black text-center text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10">
       D: STAFF (TEACHING)
      </div>
      {generateTable(table4Data, false, true)}
      <div className="text-black text-center text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10">
        E: RESULT CLASS X
      </div>
     {renderTable5(table5Data)}
      {/* <div className="text-black text-center text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10">
        F: RESULT CLASS XII
      </div> */}
      {/* {generateTable(table6Data,false,true)} */}
      <div className="text-black text-center  text-xl font-bold tracking-wider uppercase w-full max-md:max-w-full mb-3 mt-10">
        F: SCHOOL INFRASTRUCTURE
      </div>
      {generateTableF(table7Data)}    
      <div className="w-full mt-20 max-md:mt-8">
      <Footer />

      </div>
    </div>
    </div>
  );
};

export default Mpd;
